import React, { useEffect, useState } from 'react'
import { FormFooterButton, InputCss } from '../../../helper/CommonFunction';
import { ApiHandler } from '../../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../../components/ModalComponets';

const EditFueltype = ({ isOpen, onClose, showData, setResetSearch, title }) => {
    const token = useSelector(state => state.user.userToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialState = {
        fuel_type_id: '',
        fuel_type: '',
    };

    const [formData, setFormData] = useState(initialState);

    const { fuel_type_id, fuel_type } = formData;

    useEffect(() => {
        if (showData) {
            setFormData({
                fuel_type_id: showData.id || '',
                fuel_type: showData.fuel_type || '',
            });
        } else {
        }
    }, [showData, isOpen])

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        setFormData(initialState);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const body = {
            fuel_type_id: fuel_type_id,
            fuel_type: fuel_type
        }

        try {
            const result = await ApiHandler('/edit_fuelType.php', 'POST', body, token, dispatch, navigate)
            if (result.data.status === "1") {
                toast.success(result?.data.msg)
                handleClose();
                setResetSearch(true);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            handleClose();
        }
    };

    return (
        <ModalLarge isOpen={isOpen} title={title} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-4'>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-[#222] font-semibold mb-1"
                        >
                            Fuel Type
                        </label>
                        <input
                            type="text"
                            name="fuel_type"
                            value={fuel_type}
                            placeholder='Please Enter a Fuel Type'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>
                </div>

                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    )
}

export default EditFueltype;